
export const validateMinLength = (value, min_length = 6) => {

    return (value && (value.length > min_length)) ? "": "слишком короткое значение" ;
};

export const validateEmail = value => {

    let filter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return (filter.test(value)) ? "": "не правильно указан email" ;
};

export const validateNumbers = value => {

    const digit_filter = /^[0-9]*$/;

    return (digit_filter.test(value)) ? "": "допустимы только цифры" ;
};

